export const settings = {
  title: "Configuraciones",
  subtitle: "Personalizá tu experiencia con Araria",
  sections: {
    site: {
      title: "Configuraciones del Sitio",
      subtitle: "Personalizá la apariencia y el comportamiento de Araria",
    },
    api: {
      title: "Configuraciones de API",
      subtitle: "Administrá tus claves de API e integraciones",
      araria: {
        title: "Clave API Araria",
        description: "Tu clave única para acceder a los servicios de Araria",
        generate: "Generar Clave",
        regenerate: "Regenerar Clave",
        copy: "Copiar Clave",
        allowedDomains: "Dominios Permitidos",
        allowedDomainsPlaceholder:
          "Ingresá los dominios permitidos (separados por coma)",
      },
      providers: {
        title: "Proveedores de IA",
        description:
          "Configurá tus claves de API para diferentes proveedores de IA",
        openai: "Clave API OpenAI",
        anthropic: "Clave API Anthropic",
        google: "Clave API Google AI",
        placeholder: "Ingresá tu clave de API",
        save: "Guardar",
        saved: "Clave Guardada",
        delete: "Eliminar Clave", // More common than "Remover"
        notice:
          "Las claves de API se almacenan localmente en tu dispositivo y no se comparten con nuestro equipo ni con terceros.",
      },
    },
    plan: {
      title: "Plan de Suscripción",
      subtitle: "Administrá tu suscripción actual",
      current: "Plan Actual",
      upgrade: "Actualizar Plan", // Or "Mejorar Plan"
      downgrade: "Reducir Plan", // Or "Bajar de Plan"
      change: "Cambiar Plan",
    },
  },
  theme: "Tema",
  language: "Idioma",
  darkMode: "Modo Oscuro",
  lightMode: "Modo Claro",
  english: "English",
  portuguese: "Português",
  spanish: "Español",
};
